import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import { getStationTitle } from 'utils/StationUtils'
import i18n from 'simple-react-i18n'
import QualityGraphicApp from 'quality/components/graphic/QualityGraphicApp'
import { Box } from '@mui/material'
import { useParams } from 'react-router'

const DistributionUnitAssociatedGraphic = () => {
    const { id } = useParams()

    const {
        distributionUnit,
        associatedSites,
    } = useSelector(store => ({
        distributionUnit: store.DistributionUnitReducer.distributionUnit,
        associatedSites: store.StationReducer.associatedSites,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.distributionUnit,
        href: 'distributionUnit',
    }, {
        title: getStationTitle(distributionUnit),
        href: `station/distributionUnit/${id}`,
    }, {
        title: i18n.graphics,
        href: `station/distributionUnit/${id}/graphic`,
    }], [distributionUnit])

    const defaultStations = useMemo(() => {
        return associatedSites.filter(as => as.stationLinkedType === 3).map(as => as.stationLinkedId)
    }, [associatedSites])

    return (
        <Box sx={{ pl: 2 }}>
            <QualityGraphicApp
                defaultStations={defaultStations}
                hideStationsCriteria
            />
        </Box>
    )
}

export default DistributionUnitAssociatedGraphic